module.exports = __webpack_public_path__ + "static/media/instagram.dfd87d3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/instagram.svg
// module id = 1168
// module chunks = 0